import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
  MdDashboard,
  MdRestaurantMenu,
  MdShoppingBag,
  MdReviews,
  MdPayments,
  MdAnalytics,
  MdBusiness,
  MdSettings,
  MdLogout,
  MdBakeryDining,
  MdLocalShipping,
  MdStore,
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
} from "react-icons/md";

import API from "../../../services/api";

import "./MenuDrawer.css";

function MenuDrawer({
    isOpen,
    onClose,
}) {
  const navigate = useNavigate();

  const [providerType, setProviderType] = useState("");
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    fetchProvider();
  }, []);

  const fetchProvider = async () => {
    try {
      const res = await API.get("/provider/profile");
      setProviderType(res.data.provider.providerType);
    } catch (err) {
      console.log(err);
    }
  };

  const getManagementMenu = () => {
    switch (providerType) {
      case "Bakery":
        return {
          title: "Bakery Management",
          path: "/business/my-bakery",
          icon: <MdBakeryDining />,
        };

      case "Catering":
        return {
          title: "Catering Management",
          path: "/business/my-catering",
          icon: <MdLocalShipping />,
        };

      case "Provision Store":
        return {
          title: "Provision Management",
          path: "/business/my-provision",
          icon: <MdStore />,
        };

      default:
        return {
          title: "Food Management",
          path: "/business/my-foods",
          icon: <MdRestaurantMenu />,
        };
    }
  };

  const menuItems = [
    {
      title: "Dashboard",
      path: "/business/home",
      icon: <MdDashboard />,
    },

    getManagementMenu(),

    {
      title: "Orders",
      path: "/business/orders",
      icon: <MdShoppingBag />,
    },

    {
      title: "Reviews",
      path: "/business/reviews",
      icon: <MdReviews />,
    },

    {
      title: "Earnings",
      path: "/business/earnings",
      icon: <MdPayments />,
    },

    {
      title: "Analytics",
      path: "/business/analytics",
      icon: <MdAnalytics />,
    },

    {
      title: "Business",
      path: "/business/profile",
      icon: <MdBusiness />,
    },

    
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("mode");
    navigate("/login");
  };

 return (
  <>
    {/* Overlay */}
    <div
      className={`drawer-overlay ${isOpen ? "show" : ""}`}
      onClick={onClose}
    />

    {/* Drawer */}
    <aside className={`menu-drawer ${isOpen ? "open" : ""}`}>

      {/* Header */}

      <div className="drawer-header">

        <div className="drawer-logo">

          <div className="logo-circle">
            🍽
          </div>

          <div>
            <h2>HomeFoods</h2>
            <p>Business Portal</p>
          </div>

        </div>

        <button
          className="drawer-close"
          onClick={onClose}
        >
          ✕
        </button>

      </div>

      {/* Menu */}

      <nav className="drawer-menu">

        {menuItems.map((item) => (

          <NavLink
            key={item.title}
            to={item.path}
            onClick={onClose}
            className={({ isActive }) =>
              isActive
                ? "drawer-link active"
                : "drawer-link"
            }
          >
            <span className="menu-icon">
              {item.icon}
            </span>

            <span>{item.title}</span>

          </NavLink>

        ))}

        {/* Settings */}

        <button
          className="drawer-link settings-toggle"
          onClick={() =>
            setSettingsOpen(!settingsOpen)
          }
        >

          <span className="menu-icon">
            <MdSettings />
          </span>

          <span>Settings</span>

          <span className="settings-arrow">

            {settingsOpen ? (
              <MdKeyboardArrowDown />
            ) : (
              <MdKeyboardArrowRight />
            )}

          </span>

        </button>

        {settingsOpen && (

          <div className="settings-submenu">

            <NavLink
              to="/business/settings/privacy"
              className="submenu-link"
              onClick={onClose}
            >
              Privacy
            </NavLink>

            <NavLink
              to="/business/settings/security"
              className="submenu-link"
              onClick={onClose}
            >
              Security
            </NavLink>

            <NavLink
              to="/business/settings/preferences"
              className="submenu-link"
              onClick={onClose}
            >
              Preferences
            </NavLink>

            <NavLink
              to="/business/settings/danger-zone"
              className="submenu-link danger-link"
              onClick={onClose}
            >
              Danger Zone
            </NavLink>

          </div>

        )}

      </nav>

      {/* Bottom */}

      <div className="drawer-footer">

        <button
          className="logout-btn"
          onClick={handleLogout}
        >
          <MdLogout />
          Logout
        </button>

        <small>
          Version 1.0.0
        </small>

      </div>

    </aside>
  </>
);
}

export default MenuDrawer;